import React, { Component } from 'react'
import Title from './Title'
import Hero from './Hero';

export default class TextImageRightProduct extends Component {
    state={
        services:
            {
                title:"Eco-friendly Products",
                info:`Consistent with our philosophy of eco tourism, you can avail Eco-friendly products for your travel and daily use.
                Greenspace has a wide range of eco-friendly products such as travel tool kits, bamboo straws, recycled newspaper pencils, seed pencils, Dairies made 
                out of upcycled paper, Natural soaps, shampoos, face washes etc`,
                info2:`We also supply our Eco-friendly products to other Hostels, Hotels and help them have multiple revenue streams.
                 Our products are also available at various Super Markets in Goa`
            }
        
    }
    render() {
        return (
            <section className="services">
                <Title title="Eco-friendly Products" />
                <div className="services-center">
                            <span className="services">
                            
                               <Hero hero="productLargeHero" />
                                
                            </span>
                            <span className="services">
                                <div className="services">
                                <h6>{this.state.services.title}</h6>
                                <p>{this.state.services.info}</p>
                                <br />
                                <p>{this.state.services.info2}</p>
                                </div>
                                <ul className="cowork-list">
                                        <li> If you are interested in our Eco-friendly Products</li>
                                        <li> CONTACT US AT</li>
                                        <li>greenspacegoa@gmail.com</li>
                                        <li>+919049905310</li>
                                </ul>
                            </span>
                            
                </div>
            </section>
        )
    }
}
